import _ from 'lodash'

import { snakeCaseToCamelCase } from '..'

/**
 * @typedef Options
 * @property {boolean} camelCased
 */

/**
 * @param {object} props
 * @param {Options} [options]
 * @returns {object[]}
 */
export const extractGaDataProps = (props = {}, options = {}) => {
  const dataPrefix = 'data-'

  let dataProps = _.pickBy(props, (value, key) => key.includes(dataPrefix))
  const otherProps = _.pickBy(props, (value, key) => !key.includes(dataPrefix))

  if (options?.camelCased) {
    dataProps = Object.keys(dataProps)
      .reduce((acc, key) => {
        const transformedKey = snakeCaseToCamelCase(key.replace(dataPrefix, ''))
        acc[transformedKey] = dataProps[key]
        return acc
      }, {})
  }

  return [dataProps, otherProps]
}
